import './_CustomMenu.scss';
import { Button, Tooltip } from '@arkas/coreui';
import { applicationState } from '@/states/applicationState';
import { connect } from 'react-redux';
import CustomMenuItem from './CustomMenuItem';
import menuItems from '../../layouts/BasicLayout/Menu/menuItems';
import musteriMenuItems from '../../layouts/BasicLayout/Menu/musteriMenuItems';
import { NavLink } from 'react-router-dom';
import React from 'react';
import { UserDto } from '@emutabakat-types/anaveri';

interface CustomMenuProps {
  currentUser: UserDto;
}

interface CustomMenuStates {}

/**
 * CustomMenu Component
 */
class CustomMenu extends React.Component<CustomMenuProps, CustomMenuStates> {
  constructor(props: CustomMenuProps) {
    super(props);
    this.state = {};
  }
  render() {
    const { currentUser } = this.props;
    const items = currentUser.isArkasUser ? menuItems : musteriMenuItems;
    return (
      <div className="custom-menu">
        {items.map(
          item =>
            item.items && item.items.length > 0 ? (
              <CustomMenuItem
                key={item.key}
                popUpId={`mega-menu-item-${item.key}`}
                item={item}
              />
            ) : (
              <Tooltip key={item.key} title={item.title} mouseEnterDelay={1.2}>
                <NavLink to={item.url as string}>
                  <Button
                    key={item.key}
                    icon={item.icon}
                    className="custom-menu-item"
                    ghost={true}
                    style={{
                      height: '100%',
                      border: 'none',
                      lineHeight: '34px'
                    }}
                  >
                    {item.title}
                  </Button>
                </NavLink>
              </Tooltip>
            )
        )}
      </div>
    );
  }
}

const mapStateToProps = (state: applicationState) => {
  return {
    currentUser: state.kullaniciModel.currentUser
  };
};

export default connect(mapStateToProps)(CustomMenu);
